import * as React from 'react';
import { createFileRoute, redirect, useParams } from '@tanstack/react-router';

import DriversPage from '&/features/settings/drivers/pages/drivers-page';
import { useSite } from '&/features/settings/sites/hooks';

export const Route = createFileRoute('/_authenticated/settings_/sites/$siteId/drivers')({
  beforeLoad: ({ context, params }): void => {
    if (
      context.permissions.isReady &&
      !context.permissions.hasAnyPermission(['sites:manage', 'sites:access-read-only'])
    ) {
      throw redirect({ params: { siteId: params.siteId }, to: '/settings/sites/$siteId' });
    }
  },
  component: SiteDriversPage,
});

// Scope comes from the route params, not the master context: the breadcrumb scope can point
// elsewhere when browsing into a site's settings via the sites list, which would leave the
// driver drawer's scope selector unlocked (mirrors the site vehicles route).
function SiteDriversPage(): React.JSX.Element {
  const { siteId } = useParams({ from: '/_authenticated/settings_/sites/$siteId/drivers' });
  const { data: site } = useSite(siteId);
  return <DriversPage siteId={siteId} spaceId={site?.spaceId} />;
}
